//FileUploader.jsx
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage';
import { storage } from './firebase';

function FileUploader(props) {
	const [file, setFile] = useState(null);
	const [uploadProgress, setUploadProgress] = useState(0);
	const [downloadURL, setDownloadURL] = useState(props.url ? props.url : '');
	const [error, setError] = useState(null);
	const [isUploading, setIsUploading] = useState(false);
	const [isPdf] = useState(props.isPdf ? props.isPdf : false);	

	const handleFileChange = (e) => {
		if (e.target.files[0]) {
			setFile(e.target.files[0]);
			setDownloadURL('');
			props.onUpload('');
			 // Resetea la URL si se selecciona un nuevo archivo
			setError(null);	// Resetea errores
			setUploadProgress(0); // Resetea progreso
		}
	};

	const handleUpload = () => {
		if (!file) {
			setError("Por favor, selecciona un archivo primero.");
			return;
		}

		setIsUploading(true);
		setError(null);

		// Nombre seguro: sin caracteres especiales que puedan causar storage/unknown
		const safeName = (file.name || 'file').replace(/[^a-zA-Z0-9._-]/g, '_').slice(0, 100);
		const uniquePath = `uploads/${Date.now()}-${safeName}`;
		const storageRef = ref(storage, uniquePath);

		// Inicia la tarea de subida
		const uploadTask = uploadBytesResumable(storageRef, file);

		// Monitorea el estado de la subida
		uploadTask.on('state_changed',
			(snapshot) => {
				// Calcula el porcentaje de progreso
				const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
				setUploadProgress(progress);

				switch (snapshot.state) {
					case 'paused':
				break;
					case 'running':
				break;
					default:
				break;
				}
			},
			(err) => {
				console.error("Error al subir el archivo:", err);
				const serverMsg = err.serverResponse || (err.customData && err.customData.serverResponse);
				const detail = serverMsg
					? (typeof serverMsg === 'string' ? serverMsg : JSON.stringify(serverMsg))
					: err.message;
				const hint = err.code === 'storage/unknown'
					? ' Revisa las reglas de Storage en Firebase Console (Storage > Rules) y que el bucket estÃ© habilitado.'
					: '';
				setError(`Error al subir el archivo: ${detail}${hint}`);
				setIsUploading(false);
			},
			() => {
				// La subida ha terminado exitosamente, ahora obtÃƒÆ’Ã‚Â©n la URL de descarga
				getDownloadURL(uploadTask.snapshot.ref)
					.then((url) => {
					setDownloadURL(url);
					props.onUpload(url);
					setIsUploading(false);
					})
					.catch((err) => {
						console.error("Error al obtener la URL de descarga:", err);
						setError(`Error al obtener la URL de descarga: ${err.message}`);
						setIsUploading(false);
				});
			}
		);
	};
	const uid = crypto.randomUUID();
	return (
		<div className="upload-container">
			<label htmlFor={"file_"+uid}>Selecciona {isPdf ? 'Archivo': 'Imagen'}</label>
			<input id={"file_"+uid} style={{display:"none"}} type="file" onChange={handleFileChange} title={"Subir"}/>
			<button onClick={handleUpload} disabled={isUploading || !file}>
				{isUploading ? 'Subiendo...' : 'Subir'}
			</button>

			{uploadProgress > 0 && uploadProgress < 100 && (
				<div className="progress-bar-container">
					<div
				className="progress-bar"
				style={{ width: `${uploadProgress}%` }}
					>
				{Math.round(uploadProgress)}%
					</div>
				</div>
			)}

			{error && <p className="error-message">{error}</p>}

			{ ( props.url || downloadURL) && !isPdf && (
				<div className="success-message">
					<a href={downloadURL ? downloadURL : props.url } target="_blank" rel="noopener noreferrer">Descargar</a>
					<div>
						<img src={downloadURL? downloadURL : props.url} alt="Archivo Subido" style={{ maxWidth: props.imageMaxWidth ? props.imageMaxWidth : '5em', marginTop: '10px' }} />
					</div>
				</div>
			)}

			{ ( props.url || downloadURL ) && isPdf && (
				<div className="success-message">
					<a href={downloadURL ? downloadURL : props.url } target="_blank" rel="noopener noreferrer">Descargar</a>
					<div>
						Pdf Actualizado
					</div>
				</div>
			)}
		</div>
	);
}

FileUploader.propTypes = {
	url: PropTypes.string,
	onUpload: PropTypes.func.isRequired,
	isPdf: PropTypes.bool,
	imageMaxWidth: PropTypes.string,
};

export default FileUploader;